import { isValidElement } from "react";
import { Form, Heading } from "./styles";
import { BottomButtonProps, OnboardingLayoutProps } from "./types";
import { Button } from "../Button";
import { Spacing, SpacingSizes } from "../Spacing";
import { Body, H2 } from "../Typography";

export const OnboardingLayout = ({
  title,
  subtitle,
  cta: ctaProp,
  footer,
  children,
}: OnboardingLayoutProps) => {
  const cta = (() => {
    if (!ctaProp) return null;
    if (isValidElement(ctaProp)) return ctaProp;

    const { primary, secondary } = ctaProp as BottomButtonProps;

    if (!primary && !secondary) return null;

    return (
      <div>
        {primary ? <Button {...primary} /> : null}

        {secondary ? (
          <>
            <Spacing size={SpacingSizes.XS} />
            <Button {...secondary} />
          </>
        ) : null}

        <Spacing size={SpacingSizes.XL} />
      </div>
    );
  })();

  return (
    <Form autoComplete="off">
      {title ? (
        <Heading>
          {title && <H2>{title}</H2>}
          {subtitle && (
            <>
              <Spacing size={SpacingSizes.M} />
              <Body>{subtitle}</Body>
            </>
          )}
        </Heading>
      ) : null}

      {children}

      {cta}

      {footer}
    </Form>
  );
};
